import "../../styles/Components/faq/faqPublic.css";
import { BiChevronLeft } from "react-icons/bi";
import { useNavigate } from "react-router";
import {
  MdOutlineAccountBalanceWallet,
  MdOutlineHelpOutline,
  MdOutlineSyncAlt,
} from "react-icons/md";
import FaqItem from "./general/FaqItem";
import styles from "../../styles/Components/faq/IntegrationFAQ.module.css";

const questions = [
  {
    question: "How does the integration with exchanges work?",
    answer:
      "Our integration with exchanges is a seamless process that allows users to import their portfolio data, trading history, and assets from various exchanges. You can connect with up to 100 different exchanges, with the top 10 exchanges being verified for added security and reliability. ",
  },
  {
    question: "Can I trade on my integrated exchanges using AI Assistant?",
    answer:
      "Yes, with our AI Assistant, you can trade directly on your integrated exchanges. It provides a user-friendly interface for executing trades, managing your portfolio, and monitoring market conditions in real time. Whether you prefer manual or automated bot trading, AI Assistant and bots offer the flexibility you need.",
  },
];

function IntegrationFAQ() {
  const navigate = useNavigate();

  return (
    <div className={styles.helpWrapper}>
      <div className={styles.backBtn} onClick={() => navigate("/faq/all")}>
        <BiChevronLeft />
        <span>Back to Help Center</span>
      </div>

      <div className={`${styles.heroCard} ${styles.heroIntegration}`}>
        <div className={`${styles.heroIcon} ${styles.heroIconIntegration}`}>
          <MdOutlineSyncAlt />
        </div>
        <div className={styles.heroContent}>
          {/* <div className={styles.heroEyebrow}>
            <MdOutlineAccountBalanceWallet />
            Exchange Integrations
          </div> */}
          <h3 className={styles.heroTitle}>
            Integration Frequently Asked Questions
          </h3>
          <p className={styles.heroDesc}>
            Answers about connecting, syncing, and using your exchange
            integrations across the AI Assistant and bot trading features.
          </p>
        </div>
      </div>

      <div className={styles.faqCard}>
        <div className={styles.faqCardHeader}>
          <div className={styles.faqCardBadge}>
            <MdOutlineHelpOutline />
          </div>
          <div>
            <h4 className={styles.faqCardTitle}>Common Integration Questions</h4>
            <p className={styles.faqCardSubtitle}>
              Quick answers about how our exchange integrations function and
              what you can do once connected.
            </p>
          </div>
        </div>

        <ul className={styles.faqList}>
          {questions.map((faq, index) => (
            <FaqItem key={index} {...faq} id={index} />
          ))}
        </ul>
      </div>
    </div>
  );
}

export default IntegrationFAQ;
